import { render, staticRenderFns } from "./reset-email-sended.vue?vue&type=template&id=9126b76e&scoped=true"
import script from "./reset-email-sended.vue?vue&type=script&lang=js"
export * from "./reset-email-sended.vue?vue&type=script&lang=js"
import style0 from "./reset-email-sended.vue?vue&type=style&index=0&id=9126b76e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9126b76e",
  null
  
)

export default component.exports